import { Component, OnInit, Inject, EventEmitter, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { FileService } from '../../../common/services/file.service';
import { TaskSaveService } from '../../services/task-save.service';

@Component({
    selector: 'app-add-time',
    templateUrl: './add-time.component.html',
    styleUrls: ['./add-time.component.scss'],
    standalone: false
})
export class AddTimeComponent implements OnInit {

  timeFormGroup: UntypedFormGroup;
  task;
  IsSaving = false;
  constructor(
    public fb: UntypedFormBuilder,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AddTimeComponent>,
    public taskService:TaskSaveService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.task = data;
  }

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.timeFormGroup = this.fb.group({
      'tareaId': ['', Validators.required],
      'hora': ['']
    });
    let taskId = this.task.TareaId ? this.task.TareaId : this.task.tareaId;
    let hora = this.task.Hora? this.task.Hora : this.task.hora;
    this.timeFormGroup.get('tareaId').patchValue(taskId);
    if (hora) {
      const time = moment(hora).format('HH:mm');
      this.timeFormGroup.get('hora').patchValue(time);
    }
  }


  public addTime() {
    this.IsSaving = true;
    if (this.timeFormGroup.valid) {
      const model = this.timeFormGroup.value;
      this.taskService.changeTime(model)
        .subscribe(resp => {
            this.taskService.saved.emit();
            this.taskService.savedTaskSelection.emit();
            this.showSnackBar('Guardado con éxito', '', 2500);
            this.dialogRef.close();
        }, err => {
          console.error(err);
          this.showSnackBar('Se produjo un error', '', 2500);
        }, () => {
          this.IsSaving = false;
        });
    }
  }

  public cancel() {
    this.dialogRef.close();
  }

  public showSnackBar(message: string, action: string, duration: number) {
    return this.snackBar.open(message, action, {
      duration: duration
    });
  }

}
